import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card, Typography, Avatar
} from '@material-ui/core';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import gradients from 'src/utils/gradients';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  label: {
    marginLeft: theme.spacing(1)
  },
  avatar: {
    backgroundImage: gradients.green,
    height: 48,
    width: 48
  }
}));

function Buildings({ className, ...rest }) {
  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div>
        <Typography
          component="h3"
          gutterBottom
          variant="overline"
          style={{textTransform: 'none'}}
        >
          Buildings
        </Typography>
        <div className={classes.details}>
          <Typography variant="h3">
            {rest.buildings}
          </Typography>
        </div>
      </div>
      <Avatar className={classes.avatar}>
        <LocationCityIcon />
      </Avatar>
    </Card>
  );
}

Buildings.propTypes = {
  className: PropTypes.string
};

export default Buildings;
